import styles from './churn-chart.module.scss';
import WebkuaChart from '../webkua-chart/webkua-chart';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface ChurnChartProps { }

export function ChurnChart(props: ChurnChartProps) {
  return <WebkuaChart
    title={t("app.churn")}
    startDate={new Date(2023, 7, 1)}
    endDate={new Date()}
    url='charts/churn'
  />
}

export default ChurnChart;
